import css from 'styled-jsx/css';

const styles = css.global`.modal-component {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.modal-component.open {
  display: flex;
}

.modal-component .modal-surface {
  position: relative;
  width: 100%;
  max-width: 281px;
  height: 100vh;
  max-height: 440px;
  overflow: visible;
  display: flex;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  padding: 12px;
  overflow: visible;
}

.modal-component .modal-surface.allow-scroll {
  overflow: auto;
}

.modal-component .modal-content {
  box-sizing: border-box;
  position: relative;
  width: 100%;
}

.modal-backdrop {
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(24, 24, 24, 0.5);
  backdrop-filter: blur(3.5px);
}

.close-modal-btn {
  outline: none;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  height: 24px;
  width: 24px;
  position: absolute;
  top: 12px;
  right: 8px;
  z-index: 1000;
}

.close-modal-btn img {
  pointer-events: none;
  object-fit: contain;
}

@media (min-width: 992px) {
  .modal-component .modal-surface {
    max-width: 521px;
    height: calc(100vh - 20px);
    max-height: 650px;
    padding: 42px 50px;
    overflow: auto;
  }

  .close-modal-btn {
    top: 16px;
    right: 16px;
  }
}
`;

export default styles;